// extracted by mini-css-extract-plugin
export default {"button":"touchable_button__UtIEn"};